
<div class="printfooter">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-7">
      <label class="margin-bottom-0px font-family">Surgeon</label>
    </div>
    <div class="col-print-5">
      <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-7">
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-4 border-bot-1px">
          <label class="margin-bottom-0px font-family text-align-center">{{Sign1}}</label>
        </div>
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family"></label>
        </div>
      </div>
    </div>
    <div class="col-print-5">
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-6 border-bot-1px">
          <label class="margin-bottom-0px font-family text-align-center">{{Sign2}}</label>
        </div>
        <div class="col-print-5">
          <label class="margin-bottom-0px font-family"></label>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="card bordertop">
    <!--<div class="card-header border-bottom-0px border-top-1px text-align-center">
      <div class="col-md-12">
        <div class="row padding-top-10px">

          <div class="col-md-6 padding-left-20px">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f4">Corporate Office</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Kalyani Nagar Branch,</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">#26,Patalamma Temple Street,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Near Metro Station,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Bengaluru.</label>
            </div>

          </div>
          <div class="col-md-6">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f4 font-weight-normal">Contact Details</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal"><i class="fas fa-phone"></i> : 0877-224531</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal"><i class="fas fa-envelope"></i> : garbagudi&#64;healins.com</label>
            </div>

          </div>
        </div>
      </div>
    </div>-->
    <div class="card-header border-bottom-0px">

    </div>
    <div class="card-body padding-top-0px padding-bottom-0px">
      <div class="row">
        <div class="col-print-9">

        </div>
        <div class="col-print-3">
          <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-print-9">

        </div>
        <div class="col-print-3">
          <label class="margin-bottom-0px font-family13px footer_info_Mh"></label>
        </div>
      </div>
    </div>


    <!--<div class="row">
      <div class="col-md-4">
        <label class="margin-bottom-0px font-family">Print Taken On:</label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left">{{Date | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>-->
  </div>

</div>

